import { Component, OnInit } from '@angular/core';
import * as fromShared from '../../shared';
import { Observable, of } from 'rxjs';
import {
    Advisor,
    CompanyInfo
} from '../../customer-admin/customer-admin.model';
import * as fromLookup from '../../lookups';
import * as fromUser from '../../user-info';
import * as fromCompanyInfoActions from '../../customer-admin/store/company-info/company-info.actions';
import * as fromCompanyInfoReducer from '../../customer-admin/store/company-info/company-info.reducer';
import * as fromeFAACTCustomerActions from '../store/efaact-customer/efaact-customer.actions';
import * as fromeFAACTCustomerReducer from '../store/efaact-customer/efaact-customer.reducer';
import * as fromJobsActions from '../store/jobs/jobs.actions';
import * as fromJobsReducer from '../store/jobs/jobs.reducer';
import * as fromQueueJobActions from '../store/queue-job/queue-job.actions';
import * as fromQueueJobReducer from '../store/queue-job/queue-job.reducer';
import * as fromTraceLoggingOverrideActions from '../store/trace-logging-override/trace-logging-override.actions';
import * as fromTraceLoggingOverrideReducer from '../store/trace-logging-override/trace-logging-override.reducer';
import { TraceLoggingOverride } from '../store/trace-logging-override/trace-logging-override.model';
import { Store, select } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import clone from 'just-clone';
import { Job } from '../store/jobs/jobs.model';
import { eFAACTCustomer } from '../store/efaact-customer/efaact-customer.model';
import * as fromAuth from '../../auth';
import * as fromAuthR from '../../auth/store/auth.reducer';
import { QueueJob } from '../store/queue-job/queue-job.model';
import * as fromAdvisorsActions from '../../customer-admin/store/advisors/advisor.actions';
import * as fromAdvisorsReducer from '../../customer-admin/store/advisors/advisor.reducer';
@Component({
    selector: 'ef-internal-admin-feature',
    templateUrl: './internal-admin-feature.component.html',
    styleUrls: ['./internal-admin-feature.component.scss'],
    standalone: false
})
export class InternalAdminFeatureComponent implements OnInit {
    process$: Observable<fromShared.Process>;
    items$: Observable<CompanyInfo[]>;
    userInfo$: Observable<fromUser.IUserInfo>;
    states$: Observable<Array<fromLookup.IState>>;
    jobs$: Observable<Array<Job>>;
    customers$: Observable<Array<eFAACTCustomer>>;
    auth$: Observable<fromAuth.State>;
    queueJob$: Observable<Array<QueueJob>>;
    advisors$: Observable<Advisor[]>;
    traceLoggingOverrides$: Observable<TraceLoggingOverride[]>;
    selectedCustomer: Observable<any>;

    showUpdateMessage = false;
    showUpdateFailedMessage = false;

    employeeListID: string;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.auth$ = this.store.pipe(select(fromAuthR.getAuth));
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        //this.store.dispatch(fromCompanyInfoActions.getCompanyInfo());
        this.store.dispatch(fromeFAACTCustomerActions.geteFAACTCustomer());
        this.store.dispatch(fromJobsActions.getJob());
        this.store.dispatch(fromTraceLoggingOverrideActions.getTraceLoggingOverride());
        this.store.dispatch(fromAdvisorsActions.getAdvisor());
        this.setupObservables();
        this.setupSubscriptions();
    }
    ngOnDestroy() {
        this.store.dispatch(fromCompanyInfoActions.clearCompanyInfos());
    }
    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.states$ = this.store.pipe(select(fromLookup.getStates));
        this.items$ = this.store.pipe(
            select(fromCompanyInfoReducer.selectAll),
            map(x => clone(x))
        );
        this.customers$ = this.store.pipe(
            select(fromeFAACTCustomerReducer.selectAll),
            map(x => clone(x))
        );
        this.jobs$ = this.store.pipe(
            select(fromJobsReducer.selectAll),
            map(x => clone(x))
        );
        this.queueJob$ = this.store.pipe(
            select(fromQueueJobReducer.selectAll),
            map(x => clone(x))
        );
        this.advisors$ = this.store.pipe(
            select(fromAdvisorsReducer.selectAll),
            map(z => clone(z))
        );
        this.traceLoggingOverrides$ = this.store.pipe(
            select(fromTraceLoggingOverrideReducer.selectAll),
            map(x => clone(x))
        );
    }
    setupSubscriptions() {
        this.auth$.pipe(take(1)).subscribe(auth => {
            this.selectedCustomer = of(auth.CustomerID);
            // this.store.dispatch(
            //     fromCompanyInfoActions.getCompanyInfo({
            //         customerid: auth.CustomerID
            //     })
            // );
        });
        this.userInfo$.pipe(take(1)).subscribe(userInfo => {
            this.employeeListID = userInfo.EmployeeListID;
        });
    }

    onCustomerChanged(event) {
        this.store.dispatch(
            fromCompanyInfoActions.getCompanyInfo({
                customerid: event,
                IsInternal: true
            })
        );
    }

    onUpdateLicenseInfo(event) {
        this.store.dispatch(
            fromCompanyInfoActions.putCompanyInfo({ JsonString: event })
        );
    }
    onUpdateCustomerInfo(event) {
        this.store.dispatch(
            fromCompanyInfoActions.putCompanyInfo({ JsonString: event })
        );
    }
    onQueueJob(event) {
        this.store.dispatch(
            fromQueueJobActions.postQueueJob({
                employeelistid: this.employeeListID,
                customerid: event.customerid,
                jobid: event.jobid,
                storedproc: event.storedproc
            })
        );
    }
    onUpdateAdvisor(event) {
        this.store.dispatch(
            fromCompanyInfoActions.putCompanyInfo({ JsonString: event })
        );
    }

    onSaveTraceLoggingOverride(event) {
        if (event.traceLoggingOverrideId) {
            this.store.dispatch(
                fromTraceLoggingOverrideActions.putTraceLoggingOverride(event)
            );
        } else {
            this.store.dispatch(
                fromTraceLoggingOverrideActions.postTraceLoggingOverride(event)
            );
        }
    }

    onDisableTraceLoggingOverride(event) {
        this.store.dispatch(
            fromTraceLoggingOverrideActions.putTraceLoggingOverride({
                traceLoggingOverrideId: event.traceLoggingOverrideId,
                enabled: false
            })
        );
    }
}
